import { TranslationKeys } from '@nimbus-library/features/localization/models/enums/translation-keys.enum';

// noinspection JSUnusedGlobalSymbols
export enum OverlayFieldType {
  Text = 'Text',
  Picture = 'Picture',
  Map = 'Map',
}

export interface IOverlayFieldMeta {
  translation: TranslationKeys;
  type?: OverlayFieldType;
}
